export const EmptyState = ({ title, body, testid }) => (
  <div
    data-testid={testid}
    className="rounded-sm border border-dashed border-gold/40 px-8 py-16 text-center"
  >
    <span className="mx-auto mb-5 block h-2 w-2 rotate-45 bg-gold-accent" />
    <h3 className="font-serif text-2xl text-espresso">{title}</h3>
    <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-espresso/60">{body}</p>
  </div>
);
